/*@flow*/
import { useContext, useState, useEffect } from 'react';
import FormContext from '../context';
import useField from './useField';
import type { PathT } from '../types';

function usePathState(init: any, path: PathT) {
  const [value, setValue] = useState(init);
  useEffect(() => {
    setValue(init);
  }, [path.join('.')]);
  return value;
}

function stringify(path) {
  let ret = path[0] || '';
  path.slice(1).forEach(k => {
    ret += `[${k}]`;
  });
  return ret;
}

export default function useAttrs(path: PathT): any {
  const ctx = useContext(FormContext);
  const { uidGenerator } = ctx.state;
  const { fieldOptions } = useField(path);
  const attrs = fieldOptions.attrs || {};
  const id = usePathState(attrs.id || uidGenerator.next(), path);
  const name = fieldOptions.name || stringify(path);

  return { name, ...attrs, id };
}
